export default __webpack_public_path__ + "static/international-yards-desktop-157862659c4bcffa8d1ea17be44063fa.svg";